import ImageCarousel from 'components/molecules/image-carousel'
import Overlay from 'components/molecules/overlay'
import OverlaysContainer from 'components/redux-containers/overlays-container'
import PropTypes from 'prop-types'
import React from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components/macro'
import { ImageSetTypeEnum } from 'config/enums'

const ImageOverlay = styled(Overlay)`
  height: 100vh;
`

const StyledImageCarousel = styled(ImageCarousel)`
  height: 100vh;
`

function LayoutOverlays({ carAssets, closeImageOverlay, closeSearchbox, ui }) {
  const b2bCarImages = useSelector((state) =>
    Array.isArray(state?.data?.b2bCarFileAssets?.data)
      ? state.data.b2bCarFileAssets.data.filter(({ type }) => type === 'image')
      : [],
  )
  const carImages =
    ui.carouselImages ||
    (ui.imagesSetType === ImageSetTypeEnum.B2B_CAR_FILE
      ? b2bCarImages
      : carAssets &&
        carAssets.data &&
        carAssets.data.filter(({ type }) => type === 'image'))

  // Only show the layout overlay for REGULAR_CAR_FILE or B2B_CAR_FILE, other type of images.
  // This is to prevent the layout overlay from being shown for damage images or generic images which uses the same state but renders different components.
  const showCarImagesOverlay =
    ui.imageOverlayOpen &&
    (ui.imagesSetType === ImageSetTypeEnum.REGULAR_CAR_FILE ||
      ui.imagesSetType === ImageSetTypeEnum.B2B_CAR_FILE)

  return (
    <>
      {showCarImagesOverlay && (
        <ImageOverlay close={closeImageOverlay}>
          {carImages && (
            <StyledImageCarousel
              images={carImages}
              initialSlide={ui.imageOverlayImageIdx}
              fullHeight
              arrows
            />
          )}
        </ImageOverlay>
      )}
      {ui.overlay && <OverlaysContainer overlay={ui.overlay} />}
    </>
  )
}

LayoutOverlays.propTypes = {
  carAssets: PropTypes.object,
  closeImageOverlay: PropTypes.func.isRequired,
  closeSearchbox: PropTypes.func.isRequired,
  ui: PropTypes.object.isRequired,
}

LayoutOverlays.defaultProps = {
  carAssets: null,
}

export default LayoutOverlays
